// Deterministic auto-layout for /works/deeper. Replaces the per-work
// x/y/w fields the v1 default content shipped with. Produces a
// 3-column grid with subtle per-column y jitter so the page reads
// like casual film stills rather than a uniform grid.

const COLS_X = [6, 38, 67];        // % from left for left / mid / right cols
const COL_JITTER_Y = [0, 4, -2];    // small per-column vh offsets, repeating
const ROW_TOP_VH = 6;
const ROW_HEIGHT_VH = 42;
const CARD_W = 31;
const PAGE_HEIGHT_FLOOR_VH = 140;
export const PAGE_HEIGHT_TAIL_VH = 20;

export function layoutWorksGallery(count) {
  if (!count || count < 1) return [];
  const out = [];
  for (let i = 0; i < count; i++) {
    const col = i % 3;
    const row = Math.floor(i / 3);
    out.push({
      x: COLS_X[col],
      y: ROW_TOP_VH + row * ROW_HEIGHT_VH + COL_JITTER_Y[col],
      w: CARD_W,
    });
  }
  return out;
}

export function pageHeightVh(count) {
  const rows = Math.ceil(Math.max(0, count) / 3);
  return Math.max(PAGE_HEIGHT_FLOOR_VH, ROW_TOP_VH + rows * ROW_HEIGHT_VH + PAGE_HEIGHT_TAIL_VH);
}
